import { Component, OnInit } from '@angular/core';
import {RouterService} from "@biletix/core/services/router.service";
import {Locale, Region} from "@biletix/core/common";
import {I18nService} from "@biletix/core/services/i18n.service";

@Component({
  standalone: false,
  selector: 'btx-secondary-empty-footer',
  templateUrl: './empty-footer.component.html',
  styleUrls: ['./empty-footer.component.scss']
})
export class SecondaryEmptyFooterComponent implements OnInit {

  currentLocale: Locale;

  constructor(public routerService:RouterService,private i18nService: I18nService,) { 
    this.currentLocale = this.i18nService.currentLocale;
  }

  ngOnInit() {
  }

}
